import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Camera, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ logoUrl }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&q=80"
          alt="Photography background"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/80 via-[#050505]/60 to-[#050505]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Joywin's Clicks"
              className="h-40 md:h-56 lg:h-64 mx-auto object-contain"
              data-testid="hero-logo"
            />
          ) : (
            <div className="flex flex-col items-center gap-4">
              <Camera className="w-20 h-20 md:w-28 md:h-28 text-[#D4AF37]" strokeWidth={1} />
              <h1 className="font-['Playfair_Display'] text-4xl md:text-6xl gold-gradient-text" data-testid="hero-title">
                Joywin's Clicks
              </h1>
              <p className="text-[#A1A1AA] tracking-[0.3em] text-sm uppercase">
                Photos & Videos
              </p>
            </div>
          )}
        </motion.div>

        {/* Tagline */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mb-12"
        >
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-6xl text-[#EDEDED] mb-4">
            Capturing Your
            <span className="block gold-gradient-text">Precious Moments</span>
          </h2>
          <p className="text-[#A1A1AA] text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Professional photography for life's most cherished celebrations.
            Weddings, birthdays, baptisms, and more.
          </p>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link to="/book" data-testid="hero-book-btn">
            <Button className="gold-gradient-btn px-10 py-6 text-lg rounded-full">
              Book Your Session
            </Button>
          </Link>
          <Link to="/packages" data-testid="hero-packages-btn">
            <Button variant="outline" className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-10 py-6 text-lg rounded-full">
              View Packages
            </Button>
          </Link>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <ChevronDown className="w-8 h-8 text-[#D4AF37]" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
